import { render } from "./TimeArrows.vue?vue&type=template&id=46927a9c&scoped=true"
import script from "./TimeArrows.vue?vue&type=script&lang=js"
export * from "./TimeArrows.vue?vue&type=script&lang=js"

import "./TimeArrows.vue?vue&type=style&index=0&id=46927a9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46927a9c"]])

export default __exports__